export default {
  'services.slide.title': 'Our partners',
  'services.offer.title': 'Services by category',
};
